import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { catchError, map, retry, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import * as XLSX from 'xlsx';
import { Subject, throwError } from 'rxjs';
import { EmpresaService } from '../../Empresa/Empresa.service';
import Swal from 'sweetalert2';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export interface DataTiposGarantia {
  data: [];
  message: string;
  error: boolean;
}

export interface TipoGarantia {
  Descripcion: string;
  EmpresaID: string;
  TipoID: string
}

export interface Tecnico {
  EmpresaID: string;
  Personal: string;
  Tecnico: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReporteGarantiasService {
  empresaId = String(environment.empresaId);
  private destroy$ = new Subject<void>();

  constructor(private http: HttpClient, private empresaService: EmpresaService) {
    this.empresaService.empresaId$
      .pipe(takeUntil(this.destroy$))
      .subscribe((id: string) => {
        this.empresaId = id;
      });
  }

  public getGarantias(datos: any) {
    const data = {
      empresaId: this.empresaId,
      option: 'getReporteOts',
      fechaInicial: datos.fechaInicio,
      fechaFinal: datos.fechaFin,
      selectAllSucursales: datos.selectAllSucursales,
      selectAllAlmacenes: datos.selectAllAlmacenes,
      selectAllTecnicos: datos.selectAllTecnicos,
      selectAllTipos: datos.selectAllTiposGarantia,
      selectAllClientes: datos.selectAllClientes,
      sucursales: datos.sucursales,
      almacenes: datos.almacenes,
      Tecnicos: datos.tecnicos,
      Tipos: datos.tiposGarantia,
      Clientes: datos.clientes,
    };
    console.log("datos en service", data)
    return this.http.post<any>(
      environment.apiUrl + 'reportes/reporte-garantias/get_reporte_ots.php',
      data
    )
      .pipe(retry(3), catchError(this.handleError), map(data => { return data }))
  }

  getTiposGarantia() {
    const data = {
      EmpresaId: this.empresaId,
      option: 'getTiposDeGarantia'
    };
    return this.http.post<DataTiposGarantia>(
      environment.apiUrl + 'reportes/reporte-garantias/get_reporte_garantias.php',
      data
    )
      .pipe(retry(3), catchError(this.handleError), map(respuesta => { return respuesta }))
  }

  getTecnicos() {
    const data = {
      EmpresaId: this.empresaId,
      option: 'getTecnicos'
    };
    return this.http.post<DataTiposGarantia>(
      environment.apiUrl + 'reportes/reporte-garantias/get_reporte_garantias.php',
      data
    )
      .pipe(retry(3), catchError(this.handleError), map(respuesta => { return respuesta }))
  }

  exportarGarantiasAExcel(datos: any, columnas: string[]) {
    const data = {
      opcion: 'obtenerExcel', // Placeholder, cambiar a la correcta
      columnas,
      filas: datos,
      empresaId: this.empresaId
    }
    const fechaActual = new Date();
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http
      .post<any>(
        environment.apiUrl + 'reportes/reporte-garantias/reporte_garantias_excel.php', // Placeholder, cambiar a la correcta
        data,
        { headers, responseType: 'blob' as 'json' }
      )
      .pipe(map((respuesta) => {
        const blob = new Blob([respuesta], { type: 'application/vdn.ms.excel' });
        const file = new File([blob], 'Reporte_ots' + fechaActual.getDate() + '-' + (fechaActual.getMonth() + 1) + '-' + fechaActual.getFullYear() + '.xlsx', {
          type: 'application/vdn.ms.excel'
        });
        FileSaver.saveAs(file);
      }))
      .toPromise();
  }

  private handleError = (error: HttpErrorResponse | any) => {

    Swal.fire({
      type: 'error',
      title: 'Error',
      text:
        'Lo sentimos, Ocurrio un error de comunicación, Favor de contactarse con el administrador del sitio Incidencias@kabik.com.mx' + error.message
    });
    return throwError(error);
  }
}
